var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "cursor",
      rawName: "v-cursor",
      value: _vm.permission ? 'pointer' : 'default',
      expression: "permission ? 'pointer' : 'default'"
    }],
    class: _vm.$style.container,
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    class: _vm.$style.status
  }, [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:black-2",
      arg: "black-2"
    }],
    attrs: {
      "name": "basic_eagle_filled"
    }
  })], 1), _c('div', {
    class: _vm.$style.content,
    domProps: {
      "textContent": _vm._s(_vm.$t('common.declared'))
    }
  }), _vm.permission ? _c('div', {
    class: _vm.$style.action
  }, [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:violet",
      arg: "violet"
    }],
    attrs: {
      "name": "file_note-text"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }